import { render } from "./AuthSuccessful.vue?vue&type=template&id=98901022&scoped=true&ts=true"
import script from "./AuthSuccessful.vue?vue&type=script&lang=ts"
export * from "./AuthSuccessful.vue?vue&type=script&lang=ts"

import "./AuthSuccessful.vue?vue&type=style&index=0&id=98901022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98901022"]])

export default __exports__